<aux-table-panel>
  <div class="flex items-center justify-between px-4 py-2">
    <div class="text-lg">
      <p class="font-bold">Enrolled Patients Costs through End of Trial</p>
      <p class="italic">No impact on Vendor Budget Forecast — for informational purposes only</p>
    </div>

    <div class="flex space-x-2">
      <aux-export-excel-button
        [gridAPI]="gridAPI()!"
        [excelOptions]="excelOptions()"
        [disabled]="isEmptyData()"
        pendoTag="investigator-forecast-excel-export-button"
        [clickFN]="appendHiddenColumnsToExport(true)"
        [onExportSuccess]="appendHiddenColumnsToExport(false)"
      />
    </div>
  </div>

  @if (periodDataQuery.isLoading()) {
    <aux-table-skeleton />
  } @else {
    <ag-grid-angular
      class="new-flat-theme h-[360px] w-full tabular-nums"
      [gridOptions]="gridOptions()"
      [rowData]="gridData()"
      (gridReady)="onGridReady($event)"
    />
  }
</aux-table-panel>
